import { render, staticRenderFns } from "./product-query.vue?vue&type=template&id=76331f0a&scoped=true"
import script from "./product-query.vue?vue&type=script&lang=js"
export * from "./product-query.vue?vue&type=script&lang=js"
import style0 from "./product-query.vue?vue&type=style&index=0&id=76331f0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76331f0a",
  null
  
)

export default component.exports